import { meta } from '@/helpers/constants/router';
import { ADS_MANAGER_ROUTE, CREATE_AD_ROUTE, EDIT_AD_ROUTE, } from '@/helpers/constants/GlobalRoutes';
const Wrapper = () => import('@/views/Wrapper.vue');
export default [
    {
        path: 'ads-manager',
        component: Wrapper,
        redirect: ADS_MANAGER_ROUTE.name,
        meta: { ...meta, title: ADS_MANAGER_ROUTE.title },
        children: [
            {
                path: '/',
                name: ADS_MANAGER_ROUTE.name,
                component: () => import('@/views/v3/ads_manager/AdsManager.vue'),
                meta: {
                    title: ADS_MANAGER_ROUTE.title,
                    subtitle: 'Manage Your Ads here',
                },
            },
            {
                path: 'create-ad',
                name: CREATE_AD_ROUTE.name,
                component: () => import('@/views/v3/ads_manager/CreateAdSteps.vue'),
                meta: {
                    title: CREATE_AD_ROUTE.title,
                },
            },
            {
                path: 'edit-ad',
                name: EDIT_AD_ROUTE.name,
                component: () => import('@/views/v3/ads_manager/EditAdSteps.vue'),
                meta: {
                    title: EDIT_AD_ROUTE.title,
                },
            },
        ],
    },
];
